export default __webpack_public_path__ + "static/media/spaceShipG2.389bc945.webp";